import api from "./api";
import { ApiResponse } from "../types";

export interface Perfil {
  id: string;
  nome?: string | null;
  email: string;
  /** Opcional: só existe se o produtor cadastrou. Exibido ao fornecedor no portal. */
  telefone?: string | null;
  avatarUrl?: string | null;
  role: string;
  /** Admin ou Visualizador, já normalizado pela API. */
  perfil?: string;
  ultimoAcesso?: string | null;
}

export interface AtualizarPerfilPayload {
  /** String vazia limpa o telefone cadastrado. */
  telefone?: string | null;
}

export const perfilService = {
  /** Dados do usuário autenticado. Sempre vem do token, nunca de um id na URL. */
  async obter(): Promise<Perfil> {
    const r = await api.get<ApiResponse<Perfil>>("/perfil");
    if (!r.data.data) {
      throw new Error(r.data.message || "Erro ao carregar perfil");
    }
    return r.data.data;
  },

  /** Atualiza os campos editáveis. Nome, e-mail e avatar vêm do Wrike e não entram aqui. */
  async atualizar(payload: AtualizarPerfilPayload): Promise<Perfil> {
    const r = await api.put<ApiResponse<Perfil>>("/perfil", payload);
    if (!r.data.data) {
      throw new Error(r.data.message || "Erro ao salvar perfil");
    }
    return r.data.data;
  },
};
